import DetailsComponent from "./DetailsComponent";

export default DetailsComponent;
